import styled from "styled-components"

export const TabButtonsStyled = styled.div`
    display: flex;
    gap: 24px;

    @media screen and (max-width: 768px) {
        justify-content: center;
    }
`